module.exports = __webpack_public_path__ + "static/media/Sentrytocat_octodex.dc2ce237.jpg";